import { Link } from "react-router-dom";

const EXPLORE_CARDS: {
  to: string;
  label: string;
  hint: string;
  /** Hash link stays on the landing (coming-soon has no /event gate). */
  hash?: boolean;
}[] = [
  {
    to: "/dorothy",
    label: "About",
    hint: "Dorothy Ashaba and our story",
  },
  {
    to: "#poster",
    label: "Events",
    hint: "Tonight’s overnight, RSVP, and poster",
    hash: true,
  },
  {
    to: "/blog",
    label: "Blog",
    hint: "Stories and updates from the ministry",
  },
  {
    to: "/gallery",
    label: "Gallery",
    hint: "Photos from past worship nights",
  },
  {
    to: "/videos",
    label: "Videos",
    hint: "Replays and worship moments",
  },
  {
    to: "/participate",
    label: "Participate",
    hint: "Serve, give, and join in",
  },
  {
    to: "/give",
    label: "Give",
    hint: "MTN MoMo and cash at the overnights",
  },
];

export function ComingSoonExplore() {
  return (
    <section className="coming-soon-explore" aria-labelledby="coming-soon-explore-title">
      <div className="coming-soon-explore-inner">
        <div className="coming-soon-explore-head">
          <div className="coming-soon-map-eyebrow">
            <span className="rule" />
            <span>Explore</span>
            <span className="rule" />
          </div>
          <h2 id="coming-soon-explore-title" className="coming-soon-explore-title">
            More from Together In Heaven
          </h2>
          <p className="coming-soon-explore-lede">
            Secondary paths that used to crowd the header — one tap away.
          </p>
        </div>
        <div className="coming-soon-explore-grid">
          {EXPLORE_CARDS.map(({ to, label, hint, hash }) =>
            hash ? (
              <a key={to} href={to} className="coming-soon-explore-card">
                <strong>{label}</strong>
                <span>{hint}</span>
              </a>
            ) : (
              <Link key={to} to={to} className="coming-soon-explore-card">
                <strong>{label}</strong>
                <span>{hint}</span>
              </Link>
            ),
          )}
        </div>
      </div>
    </section>
  );
}
